import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Axios instance used by the admin/public UI.
 *
 * Security model:
 *  - Auth is carried by an **HTTP-only cookie** (`g66_token`) set by the backend.
 *  - Frontend NEVER reads or stores the token in localStorage (XSS mitigation).
 *  - `withCredentials: true` ensures the cookie is sent on every request (also
 *    required for cross-origin scenarios; same-origin still benefits by making
 *    the intent explicit).
 */
const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
  withCredentials: true,
});

/**
 * Longer-timeout instance for file downloads (PDFs, CSVs) that may take
 * significantly longer when generating many pages (e.g., 260+ commands).
 * Shares cookies/credentials with `api`.
 */
export const apiDownload = axios.create({
  baseURL: API_BASE,
  timeout: 120000, // 2 minutes — big enough for 500+ commands even on slow plans
  withCredentials: true,
});

const handleUnauthorized = (err) => {
  if (err.response && err.response.status === 401) {
    const path = window.location.pathname;
    if (path.startsWith('/admin') && path !== '/admin/login') {
      // Session expired or missing — redirect to login. No local cleanup needed:
      // the auth cookie is HTTP-only and cleared server-side (or already expired).
      window.location.href = '/admin/login';
    }
  }
  return Promise.reject(err);
};

api.interceptors.response.use((r) => r, handleUnauthorized);
apiDownload.interceptors.response.use((r) => r, handleUnauthorized);

export default api;
